module.exports = __webpack_public_path__ + "static/img/02.3fc818e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour6/02.jpg
// module id = yAqq
// module chunks = 0